import { NotificationRule } from '@sp-types/notificationRule';
import { getAllItems, updateItem, deleteItem, saveItemGenerateId } from './genericFB';
import { orderBy, Query, query, where } from 'firebase/firestore';

const collection = 'notification-rules';

export async function addNotifRule(notifRule: NotificationRule): Promise<NotificationRule | null> {
  return saveItemGenerateId<NotificationRule>(notifRule, collection);
}

export async function updateNotifRule(notifRule: NotificationRule): Promise<NotificationRule | null> {
  return updateItem<NotificationRule>(notifRule.id, notifRule, collection);
}

export async function deleteNotifRule(notifId: string): Promise<void> {
  deleteItem(notifId, collection);
}

export async function getNotifRules(
  accountId: string,
  formulaId: string,
  type: string,
  showActive: string,
): Promise<NotificationRule[] | undefined> {
  const queries = [
    ...(accountId ? [where('accountId', '==', accountId)] : []),
    ...(formulaId ? [where('formulaId', '==', formulaId)] : []),
    ...(type ? [where('severity', '==', type)] : []),
    ...(showActive === 'all' ? [] : [where('showActive', '==', showActive === 'active')]),
    orderBy('formulaId', 'asc'),
  ];

  return getAllItems<NotificationRule>(collection, (q: Query) => (queries.length ? query(q, ...queries) : q), true);
}

// export async function getAdminAllNotifications(): Promise<NotificationRule[] | undefined> {
//   return adminGetItems<NotificationRule>(collection);
// }
